/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function outletListStart() {
  pushClevertapEvent('Setting Outlets Start');
}

export function outletListCreateSuccess({ outlet, loggedInEmail }) {
  pushClevertapEvent('Setting Create Outlet Successful', {
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
    'Outlet City': outlet.city,
    'Outlet Province': outlet.province,
    'Outlet District': outlet.kecamatan,
    'Outlet Postal Code': outlet.postal_code,
    'Outlet ID': outlet.id,
    'Business ID': outlet.business_id,
    'Backoffice Email': loggedInEmail,
  });
}

export function outletStart() {
  pushClevertapEvent('Outlet Add');
}

export function outletPay({ billingData }) {
  pushClevertapEvent('Outlet Add Pay', {
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.add_outlet_count,
  });
}

export function editOutletSuccess({ outlet, outletId, loggedInEmail }) {
  pushClevertapEvent('Setting Edit Outlet Successful', {
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
    'Outlet City': outlet.city,
    'Outlet Province': outlet.province,
    'Outlet District': outlet.kecamatan,
    'Outlet Postal Code': outlet.postal_code,
    'Outlet ID': outletId,
    'Business ID': outlet.business_id,
    'Backoffice Email': loggedInEmail,
  });
}

export function cloneOutletOn() {
  pushClevertapEvent('Clone Outlet ON');
}

export function cloneOutletOff() {
  pushClevertapEvent('Clone Outlet OFF');
}

export function cloneOutletSuccess() {
  pushClevertapEvent('Clone Outlet Success');
}

export function cloneOutletFailed() {
  pushClevertapEvent('Clone Outlet Failed');
}
